import { render, staticRenderFns } from "./modifyProvider.vue?vue&type=template&id=52050b7e&scoped=true"
import script from "./modifyProvider.vue?vue&type=script&lang=js"
export * from "./modifyProvider.vue?vue&type=script&lang=js"
import style0 from "./modifyProvider.vue?vue&type=style&index=0&id=52050b7e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52050b7e",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/modifyProvider.vue
// module id = 2469
// module chunks = 31